import styled from 'styled-components';
import { createGradientOrSolid } from 'utils';

export const StyledCloseIconWrapper = styled.div<{ opacity: number }>`
  width: 100%;
  display: flex;
  justify-content: end;
  min-height: 50px;
  transition: opacity 0.3s ease-in-out;
  opacity: ${(props: any) => props.opacity};
`;

interface StyledHeaderProps {
  headerColor: string;
  headerSize: number;
  headerWeight: number | string;
}

interface StyledSubHeaderProps {
  textColor: string;
  textSize: number;
  textWeight: number | string;
}

export const StyledHeader = styled.h1<StyledHeaderProps>`
  text-align: center;
  margin: unset;
  color: ${(props: any) => createGradientOrSolid(props.headerColor)};
  font-size: ${(props: any) => props.headerSize + 'px'};
  font-weight: ${(props: any) => props.headerWeight};
`;

export const StyledSubHeader = styled.h2<StyledSubHeaderProps>`
  text-align: center;
  color: ${(props: any) => props.textColor};
  font-size: ${(props: any) => props.textSize + 'px'};
  font-weight: ${(props: any) => props.textWeight};
`;

export const StyledSuccessOrder = styled.div`
  font-family: var(--font-family);
  max-height: 100%;
  overflow-y: scroll;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: white;
  padding: 20px;
  overscroll-behavior: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
